const projects = [
    {
        imageUrl: 'good-food.png',
        name: 'Good Food Restaurant',
        demo: 'https://goodfood2023.herokuapp.com/',
        code: 'https://vargacar.github.io/Good_food_restaurant/'
    },
    
    {
        imageUrl: 'factory.jpg',
        name: 'The Event Factory',
        demo: 'https://project-3-template-0188627b3255.herokuapp.com/',
        code: 'https://github.com/vargacar/mixologist'
    },

    {
        imageUrl: 'explore.png',
        name: 'Explore Nearby',
        demo: 'https://knudsam.github.io/explore-nearby/',
        code: 'https://github.com/knudsam/explore-nearby'
    },

    // {
    //     imageUrl: '/profile.jpg',
    //     name: 'project name',
    //     demo: '',
    //     code: ''
    // },

    // {
    //     imageUrl: '/profile.jpg',
    //     name: 'project name',
    //     demo: '',
    //     code: ''
    // },

    // {
    //     imageUrl: '/profile.jpg',
    //     name: 'project name',
    //     demo: '',
    //     code: ''
    // }
]




export default projects